// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @13.12.2018 15:04:22
import { RbacUser_abstract } from './../../abstract/SagaBase/RBAC/RbacUser_abstract';
export class RbacUser extends RbacUser_abstract {}
